import React, { FC } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { clHeaderMenu } from 'configs/clHeaderMenu';
import Resume from 'assets/files/ThienNhanResume.pdf';

export const ClHeaderDesktop: FC = () => {
  return (
    <Navbar collapseOnSelect expand="lg" className="cl-header">
      <Container
        fluid
        className="cl-header-container d-flex justify-content-end align-items-center"
      >
        <Navbar className="cl-header-items__container">
          <Nav data-aos="fade-down" data-aos-duration="1000">
            {clHeaderMenu.map((val, index) => (
              <Nav.Link
                key={index}
                href={`/${val.path}`}
                className="cl-header-item"
              >
                {val.label}
              </Nav.Link>
            ))}
            <button
              onClick={() => window.open(Resume, '_blank')}
              data-aos="fade-down"
              data-aos-duration="1000"
              className="download-resume"
            >
              Resume
            </button>
          </Nav>
        </Navbar>
      </Container>
    </Navbar>
  );
};
